import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../client';
import { InsuranceCompany, License, MentalHealthRole, ProviderInsuranceRosterStatusEnum, ProviderInsuranceTin } from '../resources';


export const getProviderLicenses = (providerId: string) => restClient.request<{
  data: License[];
}>(`/api/v1/provider/${providerId}/license`);


export type CreateProviderLicenseInput = {
  expiration: string;
  number: string;
  stateId: string;
  mentalHealthRoleId: string;
};


export enum ProviderInsuranceArchiveReason {
  addedByMistake = 'added_by_mistake',
  noLongerInNetwork = 'no_longer_in_network',
}


export const createProviderLicense = (providerId: string, data: CreateProviderLicenseInput) => restClient.request<{
  data: License;
}>(`/api/v1/provider/${providerId}/license`, {
  method: 'POST',
  data: snakecaseKeys(data),
});



export const getProviderMissingPayers = (providerId: string) => restClient.request<{
  data: Record<string, InsuranceCompany[]>;
}>(`/api/v1/provider/${providerId}/missing_payers`);


export type UpdateProviderLicenseInput = {
  expiration: string;
  number: string;
  stateId: string;
  mentalHealthRoleId: string;
};


export const getMentalHealthRoles = () => restClient.request<{
  data: MentalHealthRole[];
}>('/api/v1/mental_health_roles');


export const getProviderInsuranceExistingTINs = (providerId: string, licenseId: string, insuranceCompanyId: string) => restClient.request<{
  data: ProviderInsuranceTin[];
}>(`/api/v1/provider/${providerId}/license/${licenseId}/${insuranceCompanyId}/existing_tins`);


export const getProviderInsuranceAvailableTINs = (providerId: string, licenseId: string, insuranceCompanyId: string) => restClient.request<{
  data: ProviderInsuranceTin[];
}>(`/api/v1/provider/${providerId}/license/${licenseId}/${insuranceCompanyId}/available_tins`);


export const addProviderInsuranceTIN = (providerId: string, licenseId: string, insuranceCompanyId: string, tins: {
  tin: string;
  effectiveDate?: string;
  rosterStatus: ProviderInsuranceRosterStatusEnum | null;
}[]) => restClient.request<{
  data: License;
}>(`/api/v1/provider/${providerId}/license/${licenseId}/${insuranceCompanyId}/tin`, {
  method: 'POST',
  data: {
    tins: snakecaseKeys(tins)
  },
});


export const removeProviderInsuranceTIN = (providerId: string, licenseId: string, insuranceCompanyId: string, tin: string, archiveReason: ProviderInsuranceArchiveReason) => restClient.request<{
  data: License;
}>(`/api/v1/provider/${providerId}/license/${licenseId}/${insuranceCompanyId}/tin`, {
  method: 'DELETE',
  data: {
    tin: tin,
    archive_reason: archiveReason,
  },
});
